import React from 'react';

/**
 * The "Bekannt durch" press banner.
 *
 * Ported verbatim from toastably-web/partials/banner-bekannt.html. Identical on every
 * landing page, which is why it is a component rather than per-page data.
 */
const TrustBanner = () => (
  <section className="section-bekannt" aria-labelledby="bekannt-title">
    <div className="container bekannt-inner">
      <p className="bekannt-heart" aria-hidden="true">
        &#9829;
      </p>
      <h2 id="bekannt-title" className="bekannt-eyebrow">
        <span className="bekannt-rule" aria-hidden="true"></span>
        Bekannt durch
        <span className="bekannt-rule" aria-hidden="true"></span>
      </h2>
      <ul className="bekannt-list">
        <li>
          <span className="bekannt-name">Alan Frei</span>
          <span className="bekannt-handle">@alanfrei</span>
        </li>
        <li>
          <span className="bekannt-name">Der Praktikant</span>
          <span className="bekannt-handle">@derpraktikanttv</span>
        </li>
        <li>
          <span className="bekannt-name">Diana</span>
          <span className="bekannt-handle">@zajanaaa</span>
        </li>
      </ul>
    </div>
  </section>
);

export default TrustBanner;
